import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import App from '@/App';
import { persistor, store } from '@/store';
import { setAuthToken } from '@/utils/agent';
import { scheduleAccessTokenRefresh } from '@/utils/authSession';
import '@/styles/global.scss';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <Provider store={store}>
      <PersistGate
        loading={null}
        persistor={persistor}
        onBeforeLift={() => {
          const { accessToken, isAuthenticated } = store.getState().auth;
          setAuthToken(accessToken);
          if (isAuthenticated && accessToken) {
            scheduleAccessTokenRefresh(accessToken);
          }
        }}
      >
        <App />
      </PersistGate>
    </Provider>
  </StrictMode>,
);
